// Voice Integrity Use Cases
export const VOICE_INTEGRITY_USE_CASES = [
    'Identify & Verification',
    'Asset Management',
    'Lead Generation',
    'Intelligent Routing',
    'Appointment Scheduling',
    'Customer Support',
    'Self-Service',
    'Automated Support',
    'Appointment Reminders',
    'Employee Notifications',
    'Delivery Notifications',
    'Emergency Notifications',
    'Contactless Delivery',
    'Order Notifications',
    'Service Alerts',
    'Purchase Confirmation',
    'Mass Alerts',
    'Fraud Alerts',
    'Contact Tracing',
    'Lead Management',
    'Lead Nurturing',
    'Telemarketing',
    'Marketing Events',
    'Rewards Program',
    'Lead Alerts',
    'Lead Distribution',
    'Abandoned Cart',
    'Call Tracking',
    'Outbound Dialer',
    'Click to Call',
    'Phone System',
    'Meetings/Collaboration',
    'Telehealth',
    'Distance Learning',
    'Shift Management',
    'Field Notifications',
    'Dating/Social',
    'Remote appointments',
    'Group Messaging',
    'Exam Proctoring',
    'Tutoring',
    'Therapy (Individual+Group)',
    'Pharmacy',
    'First Responder',
    'Survey/Research',
]
